import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PosthogPageview from './PosthogPageview';
import Home from './Home';
import FAQ from './FAQ';
import Success from './Success';
import Cancel from './Cancel';
import BugReport from './BugReport';
import Checkout from './Checkout';
import TeamCheckout from './TeamCheckout';
import './App.css';

const App: React.FC = () => {
  return (
    <Router>
      <PosthogPageview />
      <Routes>
        <Route
          path="/"
          element={<Home />}
        />
        <Route
          path="/faq"
          element={<FAQ />}
        />
        <Route
          path="/bugreport"
          element={<BugReport />}
        />
        <Route
          path="/checkout"
          element={<Checkout />}
        />
        <Route
          path="/team-checkout"
          element={<TeamCheckout />}
        />
        <Route
          path="/success"
          element={<Success />}
        />
        <Route
          path="/cancel"
          element={<Cancel />}
        />
      </Routes>
    </Router>
  );
};

export default App;
